<template>
  <Dashboard :data="salesChannels">
    <template v-slot:title>
      <h2>{{$t("salesChannel.title")}}</h2>
    </template>
    <template v-slot:filter>
      <div class="relative">
        <button
          @click="show.filter = !show.filter"
          class="outline"
        >
          <i class="fas fa-filter fa-flip-horizontal"></i>
          {{$t("button.filter")}}
        </button>
        <Filtres
          :options="options"
          :salesChannels="salesChannels"
          v-if="show.filter"
          @wipe="wipeFilter()"
          @filter="getFilter"
        ></Filtres>
      </div>
    </template>
    <template
      v-slot:buttonRight
      v-if="$store.getters.USERPROFILE['sales-channel-administration']"
    >
      <button @click="show.modal = true">
        <i class="fas fa-plus"></i>
        {{$t("button.createSalesChannel")}}
      </button>
      <Add
        v-if="show.modal"
        @close="show.modal = false"
        @get="getSalesChannels"
      ></Add>
    </template>
    <template v-slot:tab>
      <thead>
        <tr class="trHead">
          <th
            v-for="item in tab"
            :key="item.title"
            class="accentuate"
          >
            <div class="row">
              {{item.title}}
              <div
                class="column sort"
                v-if="item.title != $t('salesChannel.apiKey')"
              >
                <i
                  v-if="sort.order == -1  && item.sort==sort.type "
                  class="fas fa-sort-up up blueColor"
                  @click="(sort.type = item.sort) && (sort.order = 1)"
                ></i>
                <i
                  v-else-if="sort.order == 1 && item.sort==sort.type"
                  class="fas fa-sort-down down blueColor"
                  @click="(sort.type = item.sort) && (sort.order = -1)"
                ></i>
                <i
                  v-else-if="sort.order == 1|| item.sort!=sort.type"
                  class="fas fa-sort-down down"
                  @click="(sort.type = item.sort) && (sort.order = -1)"
                ></i>
              </div>
            </div>
          </th>
          <th></th>
          <th v-if="$store.getters.USERPROFILE['sales-channel-administration']"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="data in sortChannels"
          :key="data.title"
        >
          <td>{{data.id}}</td>
          <td>{{data.name}}</td>
          <td>{{data['merchant-name']}}</td>
          <td>{{moment(data['api-key-creation-date']).format('DD/MM/YYYY')}}</td>
          <td>
            <button
              v-if="data['api-key-status'] != 1 "
              @click="show.apiKey.id = data.id"
            >{{$t('button.see')}}</button>
            <ApiKey
              v-if="show.apiKey.id == data.id "
              :data="data"
              @close="show.apiKey.id = false"
            ></ApiKey>
          </td>
          <td>
            <p
              class="chip green"
              v-if="data['api-key-status'] === 0"
            >{{$t('salesChannel.isActive')}}</p>
            <p
              class="chip red"
              v-if="data['api-key-status'] === 1"
            >{{$t('salesChannel.isRevoqued')}}</p>
            <p
              class="chip greyBold"
              v-if="data['api-key-status'] === 2"
            >{{$t('salesChannel.isSuspend')}}</p>
          </td>
          <td>
            <p
              class="chip grey"
              v-if="data['archived']"
            >{{$t("salesChannel.isArchived")}}</p>
          </td>
          <td
            class="bubbleParent"
            v-if="$store.getters.USERPROFILE['sales-channel-administration']"
          >
            <button
              ref="bubble"
              class="outline"
              @click="bubbleClick(data.id)"
            >
              <img
                ref="bubble"
                class="pastille"
                src="@/assets/images/pastille.png"
                alt="pastille"
              >
            </button>
            <div
              class="bubble"
              v-if="bubbleAction(data.id)"
            >
              <router-link :to="{name: 'modifySalesChannel', params: { salesChannelId: data.id}}">{{$t('salesChannel.modify')}}</router-link>
              <a
                v-if="!data['archived']"
                @click="prepareArchive(data)"
                class="redText"
              >{{$t('salesChannel.archive')}}</a>
              <a
                v-if="data['archived']"
                @click="archive(data)"
              >{{$t('salesChannel.unarchive')}}</a>
              <a
                v-if="data['api-key-status'] == 0 "
                @click="changeAPIKeyStatus(data, 2)"
              >{{$t('salesChannel.suspend')}}</a>
              <a
                v-if="data['api-key-status'] == 2"
                @click="changeAPIKeyStatus(data, 0)"
              >{{$t('salesChannel.active')}}</a>
              <a
                v-if="data['api-key-status'] != 1"
                @click="prepareRevoke(data)"
                class="redText"
              >{{$t('salesChannel.revoque')}}</a>
              <a
                v-if="data['api-key-status'] == 1"
                @click="changeAPIKeyStatus(data, 0)"
              >{{$t('salesChannel.generate')}}</a>
            </div>
          </td>
        </tr>
      </tbody>
      <ConfirmationBox
        v-if="show.confirm"
        :parData="confirmationData"
        @continueprocess="continueProcess"
        @close="show.confirm=false"
      >
      </ConfirmationBox>
    </template>
  </Dashboard>
</template>

<script>
import SalesChannels from "@/services/SalesChannels";
import Dashboard from "@/components/layout/Dashboard";
import Filtres from "@/components/salesChannel/Filtres";
import Add from "@/components/salesChannel/Add";
import ApiKey from "@/components/salesChannel/ApiKey";
import compare from "@/mixins/compare";
import bubble from "@/mixins/bubble";
import getSalesChannels from "@/mixins/getSalesChannels";
import ConfirmationBox from "@/mixins/ConfirmationBox";
export default {
  mixins: [getSalesChannels, compare, bubble],
  components: {
    Dashboard,
    Add,
    Filtres,
    ApiKey,
    ConfirmationBox
  },
  data() {
    return {
      confirmationData: {
        cancel: this.$t("button.cancel"),
        data: {},
        description: "",
        proceedButton: "",
        process: "",
        title: ""
      },
      sort: {
        order: 1,
        type: "api-key-creation-date"
      },
      show: {
        filter: false,
        apiKey: {
          id: ""
        },
        modal: false,
        confirm: false
      },
      options: {
        isActive: true,
        isRevoqued: true,
        isSuspend: true,
        merchantName: {}
      }
    };
  },
  mounted() {
    this.getSalesChannels();
  },
  computed: {
    tab() {
      return [
        { title: this.$t("salesChannel.canalId"), sort: "id" },
        { title: this.$t("salesChannel.canalName"), sort: "name" },
        { title: this.$t("salesChannel.merchantName"), sort: "merchant-name" },
        {
          title: this.$t("salesChannel.apiCreationDate"),
          sort: "api-key-creation-date"
        },
        { title: this.$t("salesChannel.apiKey") },
        { title: this.$t("salesChannel.apiStatus"), sort: "api-key-status" }
      ];
    },
    channelsFilter: function() {
      return this.salesChannels.filter(channel => {
        let api = channel["api-key-status"];
        switch (api) {
          case 0:
            if (this.options.isActive) {
              return this.merchantFilter(channel);
            } else {
              return false;
            }
          case 1:
            if (this.options.isRevoqued) {
              return this.merchantFilter(channel);
            } else {
              return false;
            }
          case 2:
            if (this.options.isSuspend) {
              return this.merchantFilter(channel);
            } else {
              return false;
            }
          default:
            return false;
        }
      });
    }
  },
  methods: {
    prepareArchive(data) {
      this.confirmationData.data = data;
      this.confirmationData.proceedButton = this.$t(
        "button.confirmArchiveChannel"
      );
      this.confirmationData.process = "archiveChannel";
      this.confirmationData.title = this.$t("salesChannel.confirmArchiveTitle") + ' "' + data["name"] + " | "+data['merchant-name']+'"'
      this.confirmationData.description =
        this.$t("salesChannel.confirmArchiveDescription")
      this.show.confirm = true;
    },
    prepareRevoke(data) {
      this.confirmationData.data = data;
      this.confirmationData.proceedButton = this.$t(
        "button.confirmRevokeAPIKey"
      );
      this.confirmationData.process = "revokeAPI";
      this.confirmationData.title = this.$t("salesChannel.confirmRevokeApiTitle") + ' "' + data["name"] + " | "+data['merchant-name']+'"';
      this.confirmationData.description =
        this.$t("salesChannel.confirmRevokeApiDescription")
      this.show.confirm = true;
    },
    continueProcess(data) {
      switch (data.process) {
        case "archiveChannel":
          this.archive(data.data);
          break;
         case "revokeAPI":
          this.changeAPIKeyStatus(data.data, 1);
          break;
        default:
          break;
      }
    },

    merchantFilter(channel) {
      if (Object.keys(this.options.merchantName).length == 0) {
        return true;
      } else {
        let merchant = this.options.merchantName[channel["merchant-name"]];
        if (merchant && merchant == true) {
          return true;
        } else {
          return false;
        }
      }
    },
    wipeFilter() {
      this.show.filter = false;
      this.options = {
        isActive: true,
        isRevoqued: true,
        isSuspend: true,
        merchantName: {}
      };
    },
    archive(data) {
      SalesChannels.partialUpdate(data.id, { archived: !data.archived }).then(
        res => {
          if (res.status == 204) {
            this.getSalesChannels();
          } else {
            console.log("Error: Impossible to archive");
          }
        }
      );
    },
    changeAPIKeyStatus(data, status) {
      SalesChannels.partialUpdate(data.id, { "api-key-status": status }).then(
        res => {
          if (res.status == 204) {
            this.getSalesChannels();
          } else {
            console.log("Error: Impossible to revoque");
          }
        }
      );
    },
    getFilter(data) {
      this.options = data;
      this.show.filter = false;
    }
  }
};
</script>